import { styled } from '../../Utilities';
import { FabricBase } from './Fabric.base';
import { getStyles } from './Fabric.styles';
export var Fabric = styled(FabricBase, getStyles, undefined, {
    scope: 'Fabric'
});
//# sourceMappingURL=Fabric.js.map